import {
  TRANSLATE_INTO_JAPANESE,
  TRANSLATE_INTO_ENGLISH,
} from 'constants/actionTypes'
import { LANGUAGE } from 'constants/language'
import { Action } from 'actions'

const initialState = LANGUAGE.JP

const languageManager = (state = initialState, action: Action) => {
  switch (action.type) {
    case TRANSLATE_INTO_JAPANESE: {
      return LANGUAGE.JP
    }
    case TRANSLATE_INTO_ENGLISH: {
      return LANGUAGE.EN
    }
    default: {
      return state
    }
  }
}

export default languageManager
